import { useEffect, useRef } from "react";

function SplashCursor() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const ctx = canvas.getContext("2d");
    if (!ctx) return undefined;

    let rafId = 0;
    const particles = [];
    const pointer = { x: 0, y: 0, active: false };

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = window.innerWidth;
      const h = window.innerHeight;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };

    const spawn = (x, y) => {
      for (let i = 0; i < 3; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = 0.6 + Math.random() * 1.8;
        particles.push({
          x,
          y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 0.3,
          life: 1,
          size: 10 + Math.random() * 24,
          hue: 185 + Math.random() * 20,
        });
      }
    };

    const onMove = (e) => {
      pointer.x = e.clientX;
      pointer.y = e.clientY;
      pointer.active = true;
      spawn(pointer.x, pointer.y);
    };

    const onLeave = () => {
      pointer.active = false;
    };

    const render = () => {
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      ctx.globalCompositeOperation = "lighter";

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.97;
        p.vy = p.vy * 0.97 + 0.015;
        p.life -= 0.018;
        p.size *= 0.988;

        if (p.life <= 0.01 || p.size <= 1.5) {
          particles.splice(i, 1);
          continue;
        }

        const alpha = Math.max(p.life, 0);
        const gradient = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size);
        gradient.addColorStop(0, `hsla(${p.hue}, 95%, 72%, ${alpha * 0.65})`);
        gradient.addColorStop(0.55, `hsla(${p.hue}, 95%, 64%, ${alpha * 0.28})`);
        gradient.addColorStop(1, `hsla(${p.hue}, 95%, 54%, 0)`);

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
      }

      if (pointer.active) {
        const core = ctx.createRadialGradient(
          pointer.x,
          pointer.y,
          0,
          pointer.x,
          pointer.y,
          26
        );
        core.addColorStop(0, "rgba(125, 245, 255, 0.24)");
        core.addColorStop(1, "rgba(125, 245, 255, 0)");
        ctx.fillStyle = core;
        ctx.beginPath();
        ctx.arc(pointer.x, pointer.y, 26, 0, Math.PI * 2);
        ctx.fill();
      }

      rafId = requestAnimationFrame(render);
    };

    resize();
    render();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseleave", onLeave);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  return (
    <div className="pointer-events-none fixed left-0 top-0 z-40 h-full w-full">
      <canvas ref={canvasRef} className="h-full w-full" />
    </div>
  );
}

export default SplashCursor;
